import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import { TimeField, SelectField } from '../../../../components/fields';
import options from '../../../../text/selectOptions';
import { required } from '../../../../utilities/validation';

const RegularShift = ({ shift, index, saveTime, remove, isMobile, projects, isW2 }) => {
    const { minutes, id } = shift;
    if (!minutes && id) {
        return null;
    }

    return (
        <div className={`row ${!id ? 'addNewShift-row' : ''}`}>
            <div className={`col-xs-12  ${!id ? 'left-zero right-zero' : ''}`}>
                <div className="project">
                    <Field
                        name={`project_id$${index}`}
                        component={SelectField}
                        options={projects}
                        placeholder={messages.project}
                        validate={required}
                        disabled={projects.length < 2}
                    />
                </div>
            </div>
            {isW2 ? (
                <div className="col-xs-10">
                    <div className="regular-shift-wrapper">
                        <div className="from">
                            <div>
                                <Field name={`time_in$${index}`} component={TimeField} />
                            </div>
                        </div>
                        <div className="to">
                            <div>
                                <Field name={`time_out$${index}`} component={TimeField} />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-xs-10">
                    <div className="regular-shift-wrapper transparent">
                        <div className="col-xs-6 left-zero">
                            <Field name={`hours$${index}`} component={SelectField} options={options.hours16} placeholder={messages.hours} />
                        </div>
                        <div className="col-xs-6">
                            <Field name={`minutes$${index}`} component={SelectField} options={options.minutes} placeholder={messages.minutes} />
                        </div>
                    </div>
                </div>
            )}
            <div className="col-xs-2">
                {id ? (
                    <span className="remove-shift" onClick={() => remove(shift)}>
                        {isMobile ? <i className="material-icons">clear</i> : <FormattedMessage {...messages.remove} />}
                    </span>
                ) : (
                    <span className="button" onClick={() => saveTime()}>
                        <FormattedMessage {...messages.save} />
                    </span>
                )}
            </div>
        </div>
    );
};

RegularShift.propTypes = {
    shift: PropTypes.object,
    index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    saveTime: PropTypes.func,
    remove: PropTypes.func,
    disabled: PropTypes.bool
};

export default RegularShift;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/addTime/regularShift.jsx